import { render, staticRenderFns } from "./AjusteVerbaForm.vue?vue&type=template&id=67a4fea2&lang=html&"
import script from "./AjusteVerbaForm.vue?vue&type=script&lang=js&"
export * from "./AjusteVerbaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/orcamento/ajuste-verba/AjusteVerbaForm.vue
// module id = 1001
// module chunks = 28